export const errorMapping = {
  PAGE_NOT_ELIGIBLE: 'pageTypeInfo:doNotMeetRequirements',
};
